// @flow

import styled from 'styled-components';
import React from 'react';

type Props = {
  id: string,
  onChange: (event: any) => boolean,
  open: boolean,
  accept: string[],
  multiple?: boolean,
};

const InputField = styled.input.attrs({
  type: 'file',
  accept: (props) => props.accept.join(),
  multiple: (props) => props.multiple,
})`
  display: none;
`;

export default class FileUpload extends React.Component<Props> {
  input: HTMLInputElement;

  componentDidUpdate(prevProps: Props) {
    if (this.props.open) this.input.click();
  }

  onChange = () => {
    this.props.onChange(this.input.files);
  };

  render() {
    return (
      <InputField
        ref={(input) => (this.input = input)}
        onChange={this.onChange}
        accept={this.props.accept}
        multiple={this.props.multiple}
      />
    );
  }
}
